var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`q-pa-sm flex row rounded-borders bg-${_vm.variant}-light`},[_c('div',{staticClass:"q-mr-sm"},[_c('QIcon',{attrs:{"name":_vm.fullVariant.icon,"color":_vm.variant,"size":"24px"}})],1),_c('div',{staticClass:"col row items-center"},[_c('p',{staticClass:"text-body1"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }